import { useNavigation } from "@react-navigation/native";
import { useCallback } from "react";

import { BodyForm, CalloutRefresh } from "../components";
import { useUser } from "../services";
import { LoadingScreen } from "./loading";

export function BodyScreen() {
  // Data
  const {
    data: user,
    isLoading: isUserLoading,
    refetch: refetchUser,
  } = useUser();

  // Vars
  const navigation = useNavigation();

  // Handlers
  const handleSuccess = useCallback(() => {
    alert("Profile updated successfully!");

    navigation.goBack();
  }, [navigation]);

  // Render
  if (isUserLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <CalloutRefresh onRefresh={refetchUser} />;
  }

  return <BodyForm user={user} onSuccess={handleSuccess} />;
}
